import { Loader } from '@googlemaps/js-api-loader'

export const initGoogleMaps = () => {
	const mapEl = document.querySelector('#map')

	if (!mapEl) return

	const loader = new Loader({
		apiKey: 'AIzaSyBj_t-hYDBbZsHO7juZAfDmorhwPKn2gqA',
		version: 'weekly'
	})

	const style = [
		{
			featureType: 'administrative.land_parcel',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'administrative.locality',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'administrative.neighborhood',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'landscape.man_made',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#e5dfff'
				}
			]
		},
		{
			featureType: 'poi',
			elementType: 'labels.text',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'poi.attraction',
			elementType: 'geometry',
			stylers: [
				{
					color: '#9b82ff'
				}
			]
		},
		{
			featureType: 'poi.business',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'poi.government',
			stylers: [
				{
					color: '#9b82ff'
				}
			]
		},
		{
			featureType: 'poi.medical',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'poi.park',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#9b82ff'
				}
			]
		},
		{
			featureType: 'poi.park',
			elementType: 'geometry.stroke',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'poi.park',
			elementType: 'labels',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'poi.place_of_worship',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'poi.school',
			stylers: [
				{
					color: '#9b82ff'
				}
			]
		},
		{
			featureType: 'poi.sports_complex',
			elementType: 'geometry',
			stylers: [
				{
					color: '#9b82ff'
				}
			]
		},
		{
			featureType: 'road',
			stylers: [
				{
					color: '#9b82ff'
				}
			]
		},
		{
			featureType: 'road',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#6546fd'
				}
			]
		},
		{
			featureType: 'road',
			elementType: 'geometry.stroke',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'road',
			elementType: 'labels',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'road',
			elementType: 'labels.icon',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'road.arterial',
			stylers: [
				{
					color: '#6546fd'
				}
			]
		},
		{
			featureType: 'road.arterial',
			elementType: 'geometry.stroke',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'road.arterial',
			elementType: 'labels',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'road.highway',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#6546fd'
				}
			]
		},
		{
			featureType: 'road.highway',
			elementType: 'geometry.stroke',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'road.highway',
			elementType: 'labels',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'road.highway.controlled_access',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#6546fd'
				}
			]
		},
		{
			featureType: 'road.highway.controlled_access',
			elementType: 'geometry.stroke',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'road.local',
			stylers: [
				{
					color: '#866dfd'
				},
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'road.local',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#ad9eff'
				},
				{
					visibility: 'on'
				}
			]
		},
		{
			featureType: 'road.local',
			elementType: 'geometry.stroke',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'transit',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'transit',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#6546fd'
				}
			]
		},
		{
			featureType: 'transit',
			elementType: 'geometry.stroke',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'water',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#6546fd'
				}
			]
		},
		{
			featureType: 'water',
			elementType: 'labels.text',
			stylers: [
				{
					visibility: 'off'
				}
			]
		}
	]

	loader.load().then(async () => {
		const { Map } = await google.maps.importLibrary('maps')

		const settings = {
			lat: parseFloat(mapEl.dataset.lat),
			lng: parseFloat(mapEl.dataset.lng),
			zoom: parseFloat(mapEl.dataset.zoom)
		}

		const initMap = new Map(mapEl, {
			// center: {
			// 	lat: settings.lat,
			// 	lng: settings.lng
			// },
			center: {
				lat: 51.515632090169746,
				lng: -0.07378869089406795
			},
			styles: style,
			disableDefaultUI: true,
			zoom: settings.zoom
		})

		const position = { lat: parseFloat(settings.lat), lng: parseFloat(settings.lng) }
		const iconBase = '/dist/images/'
		const marker = new google.maps.Marker({
			position: position,
			map: initMap,
			icon: { url: iconBase + 'map-pin.png', scaledSize: new google.maps.Size(48, 48) }
		})
	})
}

export default () => {}
